import React, { useState, useEffect, useRef } from "react";

/** Shared show/hide column picker for CM Actuals Vs Forecast / Budget multi-table views. */
export default function CmActualsColumnPicker({
  classes,
  columns,
  hiddenCols,
  globalHiddenCols,
  onToggleCol,
  onShowAllCols,
}) {
  const [colPickerOpen, setColPickerOpen] = useState(false);
  const colPickerWrapRef = useRef(null);

  const isColHidden = (key) => hiddenCols.has(key) || (globalHiddenCols?.has(key));
  const hiddenCount = hiddenCols.size + (globalHiddenCols?.size ?? 0);

  useEffect(() => {
    if (!colPickerOpen) return;
    const handler = (e) => {
      if (colPickerWrapRef.current && !colPickerWrapRef.current.contains(e.target))
        setColPickerOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [colPickerOpen]);

  return (
    <div className={classes.colPickerWrap} ref={colPickerWrapRef}>
      <button
        type="button"
        className={`${classes.colsBtn} ${colPickerOpen ? classes.colsBtnActive : ""}`}
        onClick={() => setColPickerOpen((p) => !p)}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="3" width="7" height="18" /><rect x="14" y="3" width="7" height="18" />
        </svg>
        Columns
        {hiddenCount > 0 && <span className={classes.hiddenBadge}>{hiddenCount} Hidden</span>}
      </button>
      {colPickerOpen && (
        <div className={classes.colPicker}>
          <div className={classes.colPickerHeader}>
            <span className={classes.colPickerTitle}>Show / Hide Columns</span>
            {hiddenCount > 0 && (
              <button type="button" className={classes.colPickerReset} onClick={onShowAllCols}>
                Show All
              </button>
            )}
          </div>
          {columns.map((col) => (
            <label
              key={col.key}
              className={classes.colPickerItem}
              style={globalHiddenCols?.has(col.key) ? { opacity: 0.45 } : undefined}
            >
              <input
                type="checkbox"
                className={classes.colPickerCheck}
                checked={!isColHidden(col.key)}
                disabled={globalHiddenCols?.has(col.key)}
                onChange={() => onToggleCol(col.key)}
              />
              {col.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
